export const capitalizeFirstLetter = (string: string): string => string[0].toUpperCase() + string.slice(1);

export const formatAmount = (amount: string | undefined): string => {
  const numberAmount = amount ? +amount : 0;
  return numberAmount.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
};
